import useSWR from 'swr'
import type { Location } from '@/lib/types/map'

interface MapResponse {
	locations: Location[]
	totalCount: number
	totalPages: number
}

export const useFetchLocations = (
	typeFilter?: string,
	zipCode?: string,
	fetchData: boolean = true
) => {
	// Function to fetch locations
	const fetchLocations = async (url: string) => {
		const response = await fetch(url)
		if (!response.ok) throw new Error('Failed to fetch locations')

		const data = await response.json()
		// Filter invalid locations
		return data.filter(
			(location: Location) => location.latitude !== null && location.longitude !== null
		)
	}

	// Build query parameters dynamically
	let queryParams = ''
	if (typeFilter) queryParams += `type=${typeFilter}&`
	if (zipCode) queryParams += `zip=${zipCode}`

	// Trim trailing "&" or "?" if queryParams is empty
	queryParams = queryParams ? `?${queryParams}` : ''

	// Use SWR only if fetchData is true
	const shouldFetch = fetchData ? `/api/map${queryParams}` : null

	const {
		data: locations,
		error,
		isValidating,
	} = useSWR(shouldFetch, fetchLocations, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
	})

	return {
		locations: locations || [],
		isLoading: !error && isValidating,
		isError: !!error,
	}
}
